'use client'

import {
  ChartContainer,
  ChartLegend,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart'
import { useEffect, useState } from 'react'
import { Bar, BarChart, LabelList, XAxis } from 'recharts'
import RoundDisplay from '../components/roundDisplay'
import RoundSelector from '../components/roundSelector'

export default function DriverParticipationChart({
  round,
  seasonId,
  overallData,
}) {
  const [localRound, setLocalRound] = useState(round)
  const [chartData, setChartData] = useState()

  useEffect(() => {
    function formatData(data) {
      const result = {}

      data?.forEach((d) => {
        if (result[d.round_name]) {
          result[d.round_name] = result[d.round_name] + 1
        } else {
          result[d.round_name] = 1
        }
      })

      setChartData(
        Object.entries(result).map(([key, value]) => {
          return {
            round: key,
            drivers: value,
          }
        }),
      )
    }
    let data = overallData
    if (localRound !== 'All Rounds') {
      data = data.filter((d) => d.event_id === localRound.event_id)
    }
    formatData(data)
  }, [localRound, overallData])

  useEffect(() => {
    setLocalRound(round)
  }, [round])

  return (
    <div className="flex h-full flex-col items-center justify-between gap-4">
      <div className="w-full">
        <div className="flex items-center justify-between">
          <h2 className="text-p-2 font-semibold tablet:text-h-5">
            Driver Participation
          </h2>
          <RoundSelector round={localRound} setRound={setLocalRound} />
        </div>
        <p className="mb-5 w-full text-left text-p-1 text-neutral-blue-500">
          The number of drivers that participated in the event.
        </p>
        <div className="divide bg-neutral-blue-700"></div>
      </div>

      {chartData && (
        <>
          {chartData.length > 1 ? (
            <ChartContainer
              config={{
                drivers: {
                  label: 'Drivers',
                  color: 'black',
                },
              }}
              className="h-full max-h-full min-h-[100px] w-full max-tablet:aspect-[1.3]"
            >
              <BarChart accessibilityLayer data={chartData}>
                <defs>
                  <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FF6100" />
                    <stop offset="50%" stopColor="#FF4F00" />
                    <stop offset="100%" stopColor="#FF3D00" />
                  </linearGradient>
                </defs>
                <XAxis
                  dataKey="round"
                  tickLine={false}
                  tickMargin={10}
                  axisLine={false}
                  tickFormatter={(value, index) => `R${index + 1}`}
                  style={{ fill: '#627C9A' }}
                />
                <ChartTooltip
                  cursor={false}
                  content={() => <ChartTooltipContent hideLabel />}
                />

                <Bar dataKey="drivers" fill="url(#gradient)" radius={4}>
                  <LabelList
                    position="top"
                    offset={12}
                    className="fill-shades-0"
                    fontSize={12}
                  />
                </Bar>
                <ChartLegend
                  content={() => (
                    <div className="flex items-center justify-center gap-2">
                      <section className="size-2 rounded-[2px] bg-primary"></section>
                      <p className="text-p-1 text-neutral-blue-500">Drivers</p>
                    </div>
                  )}
                />
              </BarChart>
            </ChartContainer>
          ) : (
            <>
              <div className="my-auto">
                <div className="bg-gf-gradient mx-auto flex aspect-square w-min items-center justify-center rounded-full p-9">
                  <h3 className="text-[64px] font-bold">
                    {chartData?.[0].drivers}
                  </h3>
                </div>
                <div className="mt-8 flex items-center justify-center gap-2">
                  <section className="size-2 rounded-[2px] bg-primary"></section>
                  <p className="text-p-1 text-neutral-blue-500">
                    Number of Drivers
                  </p>
                </div>
              </div>
              <RoundDisplay round={localRound}></RoundDisplay>
            </>
          )}
        </>
      )}
    </div>
  )
}
